import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class PlanSalesService {
  sendConfirmationEmail(planSaleId) {
    return securedAxiosInstance.post(`/plan_sales/${planSaleId}/send_confirmation`);
  }

  fetchIndex(params) {
    return securedAxiosInstance.get("/plan_sales", { params: toSnakeCase(params) });
  }

  fetch(id, includes = []) {
    return securedAxiosInstance.get(`/plan_sales/${id}`, { params: { includes } });
  }

  fetchCSVExport(params) {
    return securedAxiosInstance.get("/admin/plan_sales/reporting", { params: toSnakeCase(params) });
  }

  fetchBillingInvoice(planSaleBillingId) {
    return securedAxiosInstance.get(`/plan_sale_billings/${planSaleBillingId}/invoice`);
  }

  update(planSaleId, formData) {
    return securedAxiosInstance.put(`/admin/plan_sales/${planSaleId}`, toSnakeCase(formData));
  }

  cancel(planSaleId, formData) {
    return securedAxiosInstance.put(`/admin/plan_sales/${planSaleId}/cancel`, toSnakeCase(formData));
  }

  updateForStore(planSaleId, storeId, formData) {
    return securedAxiosInstance.put(`/store/${storeId}/plan_sales/${planSaleId}`, toSnakeCase(formData));
  }

  cancelForStore(planSaleId, storeId, formData) {
    return securedAxiosInstance.put(`/store/${storeId}/plan_sales/${planSaleId}/cancel`, toSnakeCase(formData));
  }

  exchangeProduct(friendlyId, params) {
    return securedAxiosInstance.put(`/plan_sales/${friendlyId}/exchange_product`, toSnakeCase(params));
  }
}

export default new PlanSalesService();
